module.exports = __webpack_public_path__ + "media/images/icons/vertical_dotted_line-6e50bc9cf667bc97d35626c132e70051.svg";